import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { benefitCategories } from 'store/benefits';
import { benefitTemplateStatuses } from 'store/benefit-templates';

export const adminBenefitTemplatesFiltersSchema = z
  .object({
    category: z.array(z.enum(benefitCategories)).catch([]),
    status: z.array(z.enum(benefitTemplateStatuses)).catch([]),
    date: dateRangeSchema,
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
